(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    document.querySelectorAll('img:not([decoding])').forEach(function(img){ img.setAttribute('decoding','async'); });
    var stickyBtn = document.querySelector('[data-af-sticky-atc]');
    if(stickyBtn){ stickyBtn.addEventListener('click', function(){ var primary = document.querySelector('.ppp__btn--primary[data-add-to-cart], button[name="add"], [data-add-to-cart]'); if(primary && !primary.disabled){ primary.click(); } else { var form = document.querySelector('form[action*="/cart/add"], .ppp__purchase-card'); if(form) form.scrollIntoView({behavior:'smooth', block:'center'}); } }); }
    document.querySelectorAll('[data-af-sticky-buy-now]').forEach(function(btn){ btn.addEventListener('click', function(){ var primary = document.querySelector('[data-buy-now]'); if(primary && !primary.disabled){ primary.click(); } else { var checkout = document.querySelector('button[name="checkout"]'); if(checkout) checkout.click(); } }); });
    document.querySelectorAll('[data-af-sticky-checkout]').forEach(function(btn){ btn.addEventListener('click', function(e){ var form = btn.closest('form') || document.querySelector('form[action*="/cart"]'); if(form){ e.preventDefault(); var checkout = form.querySelector('button[name="checkout"]:not([data-af-sticky-checkout])'); if(checkout){ checkout.click(); } else { form.submit(); } } }); });
    var floatingBars = document.querySelectorAll('.af-floating-buybar');
    var scrollTick;
    window.addEventListener('scroll', function(){ if(scrollTick) clearTimeout(scrollTick); floatingBars.forEach(function(bar){ bar.classList.add('is-scrolling'); }); scrollTick = setTimeout(function(){ floatingBars.forEach(function(bar){ bar.classList.remove('is-scrolling'); }); }, 220); }, {passive:true});
    var revealTargets = document.querySelectorAll('.af-home-card,.product-card,.ppp__purchase-card,.ppp__reviews,.ppp__accordion-wrap,.af-lux-cta-band');
    revealTargets.forEach(function(el){ el.style.opacity = '0'; el.style.transform = 'translateY(14px)'; });
    if('IntersectionObserver' in window){ var io = new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.style.transition = 'opacity .45s ease, transform .45s ease'; entry.target.style.opacity = '1'; entry.target.style.transform = 'translateY(0)'; io.unobserve(entry.target); } }); }, {threshold:.08}); revealTargets.forEach(function(el){ io.observe(el); }); } else { revealTargets.forEach(function(el){ el.style.opacity = '1'; el.style.transform = 'none'; }); }
    var emailPopup = document.querySelector('[data-af-email-popup]'); var emailKey = 'af_email_discount_popup_seen_v1';
    var exitPopup = document.querySelector('[data-af-exit-popup]'); var exitKey = 'af_exit_popup_seen_v1';
    function openEmailPopup(force){ if(!emailPopup) return; if(!force && sessionStorage.getItem(emailKey)) return; emailPopup.hidden = false; sessionStorage.setItem(emailKey, '1'); var input = emailPopup.querySelector('input[type="email"]'); setTimeout(function(){ if(input) input.focus(); }, 120); }
    function closeEmailPopup(){ if(emailPopup) emailPopup.hidden = true; }
    function openExitPopup(){ if(!exitPopup || sessionStorage.getItem(exitKey)) return; if(emailPopup && !emailPopup.hidden) return; exitPopup.hidden = false; sessionStorage.setItem(exitKey, '1'); }
    function closeExitPopup(){ if(exitPopup) exitPopup.hidden = true; }
    setTimeout(function(){ openEmailPopup(false); }, 5000);
    document.querySelectorAll('[data-af-open-email]').forEach(function(btn){ btn.addEventListener('click', function(){ openEmailPopup(true); }); });
    document.querySelectorAll('[data-af-close-email]').forEach(function(btn){ btn.addEventListener('click', closeEmailPopup); });
    document.querySelectorAll('[data-af-exit-close]').forEach(function(btn){ btn.addEventListener('click', closeExitPopup); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeEmailPopup(); closeExitPopup(); } });
    document.addEventListener('mouseleave', function(e){ if(window.innerWidth > 900 && e.clientY <= 0) openExitPopup(); });
    var afExitScrollReady = false;
    window.addEventListener('scroll', function(){ if(window.scrollY > 500) afExitScrollReady = true; }, {passive:true});
    window.addEventListener('pagehide', function(){ if(afExitScrollReady) sessionStorage.setItem(exitKey, '1'); });
    var toast = document.querySelector('[data-af-review-toast]'); if(toast && !sessionStorage.getItem('af_review_toast_seen_v1')){ setTimeout(function(){ toast.hidden = false; sessionStorage.setItem('af_review_toast_seen_v1','1'); }, 6500); setTimeout(function(){ if(toast) toast.hidden = true; }, 15500); }
    document.querySelectorAll('button[name="checkout"]').forEach(function(btn){ if(btn.nextElementSibling && btn.nextElementSibling.classList && btn.nextElementSibling.classList.contains('af-checkout-note')) return; var note = document.createElement('p'); note.className = 'af-checkout-note'; note.textContent = 'Final shipping, taxes, and payment options are confirmed before payment.'; btn.insertAdjacentElement('afterend', note); });
  });
})();


(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    function bindTimer(box, minSel, secSel, storageKeyPrefix){
      if(!box) return;
      var minutes = parseInt(box.getAttribute('data-minutes') || '20', 10);
      var key = storageKeyPrefix + '_' + minutes;
      var end = parseInt(sessionStorage.getItem(key) || '0', 10);
      if(!end || end < Date.now()) { end = Date.now() + minutes * 60 * 1000; sessionStorage.setItem(key, String(end)); }
      var minEl = box.querySelector(minSel); var secEl = box.querySelector(secSel);
      function tick(){
        var diff = Math.max(0, end - Date.now());
        var mins = Math.floor(diff / 60000); var secs = Math.floor((diff % 60000) / 1000);
        if(minEl) minEl.textContent = String(mins).padStart(2,'0');
        if(secEl) secEl.textContent = String(secs).padStart(2,'0');
        if(diff <= 0){ end = Date.now() + minutes * 60 * 1000; sessionStorage.setItem(key, String(end)); }
      }
      tick(); if(minEl || secEl) setInterval(tick,1000);
    }
    document.querySelectorAll('[data-af-cart-timer]').forEach(function(box){ bindTimer(box, '[data-af-cart-min]', '[data-af-cart-sec]', 'af_cart_timer'); });
    document.querySelectorAll('[data-cart-soft-timer]').forEach(function(box){ bindTimer(box, '[data-soft-min]', '[data-soft-sec]', 'af_soft_product_timer'); });
    document.querySelectorAll('[data-home-soft-timer]').forEach(function(box){ bindTimer(box, '[data-home-min]', '[data-home-sec]', 'af_home_soft_timer'); });
  });
})();

/* Ksh currency spacing normalize - lightweight */
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}
  function norm(t){
    if(!t) return t;
    t = String(t).replace(/KSh\s*/gi, 'Ksh ').replace(/Ksh\s*/g, 'Ksh ').replace(/KES\s*/gi, 'Ksh ');
    t = t.replace(/Ksh\s+/g, 'Ksh ');
    if(/^[\s$£€]\s*[0-9,.]+\s*$/.test(t)) t = 'Ksh '+t.replace(/[\s$£€]/g,'');
    return t;
  }
  function normFormat(format){ return norm(String(format || '')).replace(/Ksh\s+\{\{/g, 'Ksh {{'); }
  if(window.theme && window.theme.moneyFormat){ window.theme.moneyFormat = normFormat(window.theme.moneyFormat); }
  ready(function(){
    if(window.theme && window.theme.moneyFormat){ window.theme.moneyFormat = normFormat(window.theme.moneyFormat); }
    function scan(){
      var selector = '.price,.money,.product-single__price,.ecom-product-single__price--sale,.ecom-product-single__price--regular,.ecom-collection__product-price,.ecom-collection__product-price--regular,[data-sticky-price],[data-af-cart-sticky-total],.cart__item-total,.cart__subtotal,.af-product-bundle__price';
      document.querySelectorAll(selector).forEach(function(e){
        if(e.children.length===0){ e.textContent = norm(e.textContent); e.classList.add('af-kes-normalized'); }
      });
    }
    scan();
    setTimeout(scan, 800);
    setTimeout(scan, 1600);
    document.addEventListener('variantChange', function(){ setTimeout(scan, 50); }, true);
    document.addEventListener('variantPriceChange', function(){ setTimeout(scan, 50); }, true);
    if(document.querySelector('[data-af-cart-sticky-total]')){
      fetch('/cart.js').then(function(r){return r.ok?r.json():null}).then(function(c){
        if(!c) return;
        var total=(c.total_price/100).toLocaleString('en-KE',{minimumFractionDigits:2,maximumFractionDigits:2});
        document.querySelectorAll('[data-af-cart-sticky-total]').forEach(function(e){e.textContent='Ksh '+total;});
      }).catch(function(){});
    }
  });
})();

/* Bundle add to cart from product page */
(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    document.querySelectorAll('.af-product-bundle__form').forEach(function(form){
      form.addEventListener('submit', function(e){
        if(!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var msg = form.querySelector('[data-af-bundle-message]');
        var original = btn ? btn.textContent : '';
        if(btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
        if(msg){ msg.textContent = ''; }
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        }).then(function(res){
          if(!res.ok) throw new Error('Unable to add');
          return res.json();
        }).then(function(){
          if(btn){ btn.textContent = 'Added'; }
          if(msg){ msg.textContent = 'Added to cart'; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function(){ if(btn){ btn.disabled = false; btn.textContent = original || 'Add to cart'; } if(msg){ msg.textContent = ''; } }, 1800);
        }).catch(function(){
          if(btn){ btn.disabled = false; btn.textContent = original || 'Add to cart'; }
          if(msg){ msg.textContent = 'Please try again'; }
        });
      });
    });
  });
})();


/* Buy Now: add selected product to cart and go straight to checkout */
(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    document.querySelectorAll('[data-buy-now]').forEach(function(button){
      var form = button.closest('form[action*="/cart/add"]') || button.closest('form');
      var addBtn = form ? form.querySelector('button[name="add"]') : null;
      function syncState(){
        if(!addBtn) return;
        button.disabled = !!addBtn.disabled;
        button.setAttribute('aria-disabled', addBtn.disabled ? 'true' : 'false');
      }
      syncState();
      if(addBtn && window.MutationObserver){
        new MutationObserver(syncState).observe(addBtn, { attributes:true, attributeFilter:['disabled','class'] });
      }
      document.addEventListener('variantChange', function(){ setTimeout(syncState, 30); }, true);
      button.addEventListener('click', function(e){
        e.preventDefault();
        if(button.disabled || !form) return;
        if(!window.fetch || !window.FormData){
          form.setAttribute('action','/cart/add?return_to=/checkout');
          form.submit();
          return;
        }
        var original = button.textContent;
        button.disabled = true;
        button.textContent = 'Processing...';
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        }).then(function(res){
          if(!res.ok) throw new Error('Unable to add item');
          window.location.href = '/checkout';
        }).catch(function(){
          button.disabled = false;
          button.textContent = original || 'Buy Now';
          if(addBtn && !addBtn.disabled){ addBtn.click(); }
        });
      });
    });
  });
})();
